import React from 'react';
import Fade from 'react-reveal/Fade';

const Local = () => (
  <section className="fade inactive" id="local">
    <Fade duration={2500}>
      <iframe
        allowFullScreen
        frameBorder="0"
        height="400"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15545.851205861165!2d-55.94657605141535!3d-13.069829351542433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x93a0f1645673f533%3A0xaafeb8501dd3d616!2sFaculdade%20La%20Salle!5e0!3m2!1spt-BR!2sbr!4v1581008776024!5m2!1spt-BR!2sbr"
        style={{ border: 0 }}
        width="100%"
      ></iframe>
    </Fade>
  </section>
)
export default Local;
